import { addMonths, format, max, startOfMonth, subMonths } from "date-fns";

export const MAX_MONTHS = 60;

export interface SelectOption {
  value: string;
  label: string;
}

const toKey = (date: Date): string => format(date, "yyyy-MM");

const fromKey = (key: string): Date => {
  const [year, month] = key.split("-").map(Number);
  return new Date(year, month - 1, 1);
};

const effectiveStart = (earliestMonth: string, today: Date): Date =>
  max([fromKey(earliestMonth), subMonths(startOfMonth(today), MAX_MONTHS - 1)]);

export const buildMonthOptions = (
  earliestMonth: string,
  today: Date,
): SelectOption[] => {
  const latest = startOfMonth(today);
  const options: SelectOption[] = [];
  for (
    let cursor = effectiveStart(earliestMonth, today);
    cursor <= latest;
    cursor = addMonths(cursor, 1)
  ) {
    options.push({ value: toKey(cursor), label: format(cursor, "MMMM yyyy") });
  }
  return options;
};

export const defaultMonthKey = (earliestMonth: string, today: Date): string =>
  toKey(
    max([
      subMonths(startOfMonth(today), 1),
      effectiveStart(earliestMonth, today),
    ]),
  );
